<template>
  <b-form-row>
    <b-modal @hidden="cancelar" size="xl" button-size="sm" ref="finder" hide-footer :id="this.id"
      :title="prefix + title">
      <SubgrupoProdutoList :currentGrupo="grupoProduto" @onDblClickSubgrupo="subgrupoSelect" :title="prefix + title"
        :addBtnVisible="false" />
    </b-modal>

    <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
      invalidFeedback="Subgrupo deve ser informado!" description="" @handleClean="subgrupoSelect" >
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed v-if="user !== null" :disabled="disabled">
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import SubgrupoProdutoList from "@/modules/cadastros/grupo-produto/SubgrupoProdutoList.vue"

export default {
  name: "LgFinderPageSubgrupoProduto",
  components: { LgFormInputFinder, SubgrupoProdutoList },

  props: {
    id: String,
    grupoProduto: Object,
    user: Object,
    value: Object,
    disabled:{
      type: Boolean,
      default: false,

    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Subgrupo",
    },
    label: {
      type: String,
      default: "Subgrupo:",
    },
  },

  data() {
    return {
      descricao: "",
      localValue: this.value,
    }
  },

  watch: {
    value(newValue) {
      this.localValue = newValue
    },
  },
  methods: {
    subgrupoSelect(subgrupo) {
      this.$emit("onSelect", subgrupo)
      this.$refs.finder.hide()
    },
    async show() {
      await this.$refs.finder.show()
      this.$bvModal.show(this.id)
    },
    cancelar() {
      this.$emit("close")
    },

  },
}
</script>
